/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
//styles
import "./index.css";

import { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { useParams, Link } from "react-router-dom";
import { Image, Card } from "antd";

//actions
import { product, productCleanup } from "../../Store/actions/product";
import {
  productProgram,
  productProgramCleanup,
} from "../../Store/actions/productProgram";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { LoadingOutlined } from "@ant-design/icons";

const Product = () => {
  const { _id } = useParams();
  const dispatch = useAppDispatch();
  const productState = useAppSelector((state) => state.product);
  const productProgramState = useAppSelector((state) => state.productProgram);
  const [productDetails, setProductDetails] = useState<any>({});
  const [programID, setProgramID] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    dispatch(product({ _id }));
    dispatch(productProgram({ _id }));
  }, []);

  useEffect(() => {
    if (productState.isSuccessful) {
      setProductDetails(productState.data);
      dispatch(productCleanup());
    } else if (productState.error) {
      setError(productState.error);
      dispatch(productCleanup());
    }
  }, [productState]);

  useEffect(() => {
    if (productProgramState.isSuccessful) {
      setProgramID(productProgramState.data[0]._id);
      dispatch(productProgramCleanup());
    } else if (productProgramState.error) {
      setProgramID('');
      dispatch(productProgramCleanup());
    }
  }, [productProgramState]);

  return (
    <div className="product">
      {error && <p className="text-center">{error}</p>}
      {
        productProgramState.isLoading && productState.isLoading ? (
          <div className="text-center py-5 w-100" style={{minHeight: '40vh'}}>
            <LoadingOutlined style={{ fontSize: 30 }} spin />
          </div>
        ): (
          <>
            {productDetails.title && (
              <Container>
                <Row>
                  <Col md="4" sm="12">
                    <Image
                      src={productDetails.avatar.secure_url || ""}
                      alt={productDetails.title}
                      preview={false}
                      crossOrigin="anonymous"
                      fallback="data:image/png;base64,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"
                    />
                  </Col>
                  <Col md="8" sm="12">
                    <Card title={productDetails.title} style={{}}>
                      <p>
                        Brand: <span>{productDetails.brand}</span>
                      </p>

                      <p>
                        Type: <span>{productDetails.productType}</span>
                      </p>
                      <p>
                        Category: <span>{productDetails.category}</span>
                      </p>

                      <p>
                        Location:{" "}
                        <span>{(productDetails.city, productDetails.state)}</span>
                      </p>

                      <p>
                        Address: <span>{productDetails.address}</span>
                      </p>

                      <p className="mb-0">
                        ${productDetails.sellingPrice - productDetails.discount}
                      </p>

                      <p id="selling">${productDetails.sellingPrice}</p>
                      <Link className="text-white" to={`/programs/${programID}`}>
                        <button className="btn btn-secondary btn-sm">
                          View program
                        </button>
                      </Link>

                      <h6 className="mt-3">Description</h6>
                      <p>{productDetails.description}</p>
                    </Card>
                  </Col>
                </Row>
              </Container>
            )}
          </>
        )
      }
    </div>
  );
};

export default Product;
